module.exports = __webpack_public_path__ + "img/23.f9c20e01.jpg";